<template>
  <div class="race-question">
    <modal name="question" @before-close="onClose">
      <div class="question-modal-content">
        <div class="image">
          <i class="fa-solid fa-question-circle"></i>
          <h1>Today's Question</h1>
        </div>
        <div class="question-textarea-wrapper">
          <textarea v-model="question" id="Question" maxlength="255" name="question" Placeholder="enter your question here"></textarea>
        </div>
        <div class="question-button-wrapper">
          <button class="btn btn--primary"  v-on:click="isquestionId?Update(question):Save(question)" :disabled= "isClicked">{{button}}</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import {
    db
  } from '../../../firebase'

  // import ListRace from '@/components/Races/List'

  export default {
    name: 'race-question',
    data: () => ({
     question: '',
     isquestionId: false,
     isSaved:false,
     button:'',
     isClicked:false
    }),
    props:{
      show:false,
      todayQuestion:{},
      raceId:null
    // },
    // computed: {
    //   show: {
    //     // getter
    //     get: function() {
    //       return this.showMe
    //     },
    //     // setter
    //     set: function(newValue) {
    //       console.log(newValue)
    //       if (newValue)
    //         this.$modal.show('question')
    //     }
    //   }
    },

    mounted() {
        //this.$parent.$emit('closed', true)
    },
    computed: {
      ...mapGetters({
        race: 'Race/race',
        questions: 'RaceQuestion/raceQuestion'
      })
    },
    // firebase: {
    //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
    // },
    methods: {
      onClose() {
        this.$parent.$emit('closed', true)
        this.$emit('saved', true)
      },
      Save: function(question){
         this.isClicked = true
            var raceQuestion = {
              question:question,
              race: {
                id: this.raceId
              }
            }
            this.createRaceQuestion(raceQuestion)
              .then(() => {
                this.isSaved = true
                  var obj = {
                    id: this.raceId,
                    val: true
                  }
                this.$emit('saved', obj)
                this.$modal.hide('question')
                this.isClicked = false

              })
              .catch(() => {
                 console.log('failed')
              })

      },
      Update: function(question){
        this.isClicked = true
            var raceQuestion = {
              id: this.todayQuestion.id,
              question:question,
              raceQuestionType: this.todayQuestion.raceQuestionType,
              race: {
                id: this.raceId
              }
            }
            this.updateRaceQuestion(raceQuestion)
              .then(() => {
                // this.$firebaseRefs.${this.$fbDbEntry}.child(this.$route.params.raceId).update({
                //   'standBy': true
                // })
                 var obj = {
                    id: this.raceId,
                    val: true
                  }
                  this.$emit('saved', obj)
                this.$modal.hide('question')
                 this.isClicked = false

              })
              .catch(() => {
                 console.log('failed')
              })

      },
      ...mapActions({
        createRaceQuestion: 'RaceQuestion/createOne',
        updateRaceQuestion: 'RaceQuestion/updateOne'
      })
    },

    watch: {
      show(oldVal, newVal) {
        if (this.show)
          this.$modal.show('question')
          this.question = this.todayQuestion.question
          if(this.todayQuestion.id){
            this.isquestionId = true
            this.button = 'Update'
          }else{
            this.isquestionId = false
            this.button = 'Save'
          }
      }
    },
    Save () {
    },
    created() {
      this.$watch('show', function (val) {
      })
    },
  }
</script>
<style>
.race-question .sweet-modal-overlay{
    z-index: 998;
}

.question-modal-content {
    padding: 20px;
}

.question-modal-content .image {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;
}

.question-modal-content .image i {
    font-size: 24px;
    color: #423799;
}

.question-modal-content .image h1 {
    margin: 0;
}

.question-textarea-wrapper {
    margin-bottom: 15px;
}

.question-textarea-wrapper textarea {
    width: 100%;
    height: 80px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-family: inherit;
    box-sizing: border-box;
    resize: vertical;
}

.question-button-wrapper {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// Question.vue?40b3a336